import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery, baseService, GLOBAL_TAG_TYPES } from '@repo/services';

export const TAG_TYPES = GLOBAL_TAG_TYPES;

export const baseServiceWithoutRefresh = createApi({
  reducerPath: 'baseApiServiceWithoutRefresh',
  tagTypes: Object.values(TAG_TYPES),
  baseQuery,
  endpoints: () => ({}),
});

export default baseService;
